/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".colhidden[_ngcontent-%COMP%] {\n  display: none; }\n\n.bordernodata[_ngcontent-%COMP%] {\n  border-top: none;\n  line-height: 35px; }\n\n.btn-info[_ngcontent-%COMP%]:disabled {\n  cursor: not-allowed; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customer-req-doc/customer-req-doc.component.scss.shim.ngstyle.js.pre-build-optimizer.js